<template>

  <v-app id="inspire" style="background:#161616;" >

    <div class="display-1 mx-auto my-7 px-8 text-center" 
    style="text-shadow:0 0 2px rgb(0, 0, 0),0 0 3px rgb(0, 255, 42),0 0 17px rgb(226, 0, 226),0 0 47px rgb(0, 183, 255); color:#faf0ff,0 0 67px rgb(0, 214, 36); color:#faf0ff"  v-if="NFCCODE2()">{{nfctag2.name}}</div>
    <p v-if="NFCCODE2()"></p>
 


    
    <div v-if="NFCCODE()" style="animation: movinglight 5s ease  2s infinite normal forwards;display:block; 
    position:absolute; left: calc(50% - 150px); margin-top:60px; border-radius:300px; width:300px; height:300px;  
    box-shadow:0 0 180px rgb(4, 0, 255), inset 0 0 155px rgba(255, 255, 255, 0.4)" ></div>
  
    <v-card :dark="true" v-if="NFCCODE()" width="350" class="my-9 mx-auto"
      style="background:#252525;border-radius:20px; box-shadow:0 0 1520px rgba(112, 2, 126, 0.862) ">
      <v-system-bar color="#00810d" outlined class="white--text" style="height:90px; font-size:1.2rem;">
    
        <img
          style=" margin-top:  10px  ; margin-left:10px;  margin-bottom:10px; opacity:80%;box-shadow:0 0 2px rgb(26, 26, 26),0 0 12px rgb(0, 255, 64) "
          src="img2.png" />
        <v-spacer />
        <div class=" text-center"
          style="line-height:1.2rem;font-size:1rem; margin:10px;  color:rgb(255, 255, 255);text-shadow:0 0 2px rgb(26, 26, 26),0 0 12px rgb(0, 255, 64)">
          {{nfctag.name}}
        </div>
        <v-spacer />
    
      </v-system-bar>
      <table cellspacing="0" cellpadding="0" height="100" width="350">
        <tr>
          <td align="center"
            style="font-size:1.3rem;padding: 30px; color:#cdcdcd ;text-shadow:0 0 2px rgb(26, 26, 26),0 0 12px rgb(0, 255, 64) ">
            Введите e-mail или выберите
            <br />
            <v-form v-model="valid" @submit.prevent="dostup">
              <v-container>
                <v-combobox hide-details :dark="true" solo class="my-8 mt-3" dense v-model="nfctag.email"
                  :items="regulators.map(x=>x.email)"
                  style="color:#cdcdcd;box-shadow:0 0 2px rgb(26, 26, 26),0 0 127px rgb(0, 255, 64) " />
                <v-btn style="background:#00810d;text-shadow:0 0 2px rgb(26, 26, 26),0 0 12px rgb(0, 255, 64)"
                  @click="sendlink" submit>отправить ссылку</v-btn>
    
              </v-container>
            </v-form>
            <br />
    
          </td>
        </tr>
      </table>
    </v-card>



    <div v-if="NFCCODE2()" style="width:95vw; margin:0px auto; border:7px solid rgba(110, 59, 110, 0.15); max-height:85vh; padding:25px; border-radius:50px;">
<div style="width:90vw; margin:0px auto; overflow-x:auto;overflow-y:auto; max-height:79vh; ">
>
    <table  cellspacing="7" cellspadding="0" border="0"
      :style="'margin:0px auto; width:' + nfctag2.record.length*450 +'px'">
      <tr>
        <td valign="top" style="width:350px; padding-top:20px;border-radius:60px;border:7px solid rgba(110, 59, 110, 0.15); " v-for="(item,ind) in nfctag2.record"
          v-bind:key="item">
    
           
    <div style="font-size:15pt; font-weight:400;margin-right:40px;margin-left:40px;
    text-shadow:0 0 1px rgb(17, 0, 255),  0 0 3px rgb(174, 2, 180); color:rgb(255, 255, 255); 
    text-align:center; box-shadow:0 0 8px rgba(96, 16, 224, 0.946),0 0 17px rgb(68, 36, 61);
    padding:10px;border:1px solid rgba(30, 99, 0, 0.485); border-radius:25px;
    margin-top:10px;line-height:1.3em;">{{nfctag22[ind].org}}: {{nfctag22[ind].tip}}, {{nfctag22[ind].period}}, {{nfctag22[ind].vid_rascheta}} 
    
  </div>
        
          <v-card v-for="pod in JSON.parse(nfctag22[ind].podachi)"   v-bind:key="pod" :dark="true" width="350" class="my-9 mx-auto"
            style="background:#252525;border-radius:20px; box-shadow:0 0 10px rgba(152, 252, 255, 0.262),0 0 1520px rgba(112, 2, 126, 0.862) ">
            <v-system-bar color="#00810d" outlined class="white--text" style="height:90px; font-size:1.2rem;">
    
              <img
                style=" margin-top:  10px  ; margin-left:10px;  margin-bottom:10px; opacity:80%;box-shadow:0 0 2px rgb(26, 26, 26),0 0 12px rgb(0, 255, 64) "
                src="img2.png" />
              <v-spacer />
              <div class=" text-center shadow"
                style="line-height:1.2rem;font-size:1rem; margin:10px; color:rgb(255, 255, 255);text-shadow:0 0 2px rgb(26, 26, 26),0 0 12px rgb(0, 255, 64)">
               {{pod.name}}: {{pod.opisanie}}
              </div>
              <v-spacer />
    
            </v-system-bar>
            <table cellspacing="0" cellpadding="0" height="100" width="350">
              <tr>
                <td align="center"
                  style="font-size:1.3rem;padding: 30px; color:#cdcdcd ;text-shadow:0 0 2px rgb(26, 26, 26),0 0 2px rgb(0, 255, 64) ">
                  <a class="my-2" target="_blank" style=" background: rgba(112, 112, 112, 0.211) ;font-size:10pt;display:block;border:1px solid rgb(71, 66, 68); padding:7px; border-radius:8px; width: 80%;color:rgb(255, 255, 255); text-decoration: none;"  :href="'https://dela.website.yandexcloud.net/'+nfctag22[ind].folder+'/'+pod.doc"><v-icon  class="mx-1 my-2" >mdi-book-open-page-variant</v-icon>ДЕЛО</a>
                  <a class="my-2"  style=" background: rgba(112, 112, 112, 0.211) ;font-size:10pt;display:block;border:1px solid rgb(71, 66, 68); padding:7px; border-radius:8px; width: 80%;color:rgb(255, 255, 255); text-decoration: none;"  @click="podacha.name=nfctag22[ind].org+':'+nfctag22[ind].tip+', '+nfctag22[ind].period+', '+nfctag22[ind].vid_rascheta+'. '+pod.name+':'+pod.opisanie; podacha.reestr=pod.reestr.map(el=>el.name); reestr_dialog=true" ><v-icon  class="mx-1 my-2" >mdi-clipboard-text</v-icon>РЕЕСТР</a>
                  <a class="my-2" target="_blank" v-for="doc in pod.docs" v-bind:key="doc" style="background: rgba(112, 112, 112, 0.211) ;font-size:10pt;display:block;border:1px solid rgb(71, 66, 68);  padding:7px; border-radius:8px; width: 80%;color:rgb(255, 255, 255); text-decoration: none;"  :href="'https://dela.website.yandexcloud.net/'+nfctag22[ind].folder+'/'+doc.link"><v-icon  class="mx-1 my-2">mdi-file</v-icon>{{doc.name}}</a>
                 
    
                </td>
              </tr>
            </table>
    </v-card>


        </td>
      </tr>
    </table>
    </div>
    </div>
  
    





        <v-dialog
        transition="dialog-bottom-transition"
        max-width="600"
        v-model="snackbarOK"
        style="border-radius: 25px; border:1px solid rgb(6, 255, 6);"
      >

      

       
          <v-card style="border-radius: 25px; border:1px solid rgb(6, 255, 6);  ">
            <v-toolbar
              color="success darken-4"
              :dark="true"
              class="outline"
              style="background: #019c30; color:#00ff1e;text-transform:uppercase"
            >Отправлено успешно</v-toolbar>
            <v-card-text :dark="true" style="background: #003610; color:#48ff5a;text-transform:uppercase">
              <div  class="text-h2 pa-12">{{oktext}}</div>
            </v-card-text>
            <v-card-actions class="justify-end"   style="background: #005c1c; ">
              <v-btn
                text
                @click="snackbarOK = false; "
                style="color:#00ff1e"
              >Закрыть</v-btn>
            </v-card-actions>
          </v-card>

      </v-dialog>



<v-dialog
        transition="dialog-bottom-transition"
        max-width="600"
        v-model="reestr_dialog"
        style="border-radius: 25px; border:1px solid rgb(6, 255, 6);"
      >

<v-card style="border-radius: 25px; border:1px solid rgb(6, 255, 6);  ">
            <v-toolbar
              color="success darken-4"
              :dark="true"
              class="outline"
              style="background: #019c30; color:#00ff1e;text-transform:uppercase"
            >Реестр документов </v-toolbar>
            <v-card-text :dark="true" style="overflow-y: auto; height:70vh; background: #003610; color:#48ff5a;text-transform:uppercase">

              
              <div class="pt-5" style="border-bottom:1px solid rgba(92, 92, 92, 0.541);font-size:9pt; color:rgb(84, 212, 101);; line-height: 1.5em;" >
                {{podacha.name}} 
                </div>
              <div  class="text-h2 pa-12">
                <div style="border-bottom:1px solid rgba(92, 92, 92, 0.541);font-size:8pt; color: rgb(84, 212, 101); line-height: 1.7em;" v-for="(el,ind) in podacha.reestr" v-bind:key="el">
                {{ind+1}}) {{el}}
                </div>
              </div>
            </v-card-text>
            <v-card-actions class="justify-end"   style="background: #005c1c; ">
              <v-btn
                text
                @click="reestr_dialog = false; "
                style="color:#00ff1e"
              >Закрыть</v-btn>
            </v-card-actions>
          </v-card>

      </v-dialog>


















  </v-app>
</template>

<script>

  import qs from 'qs'

  const axios = require('axios').default;




  export default {
    components: {

    },
    props: {
      source: String,
    },
    data: () => ({
      podacha: {
        name:'',
        reestr:[]
      },
      reestr_dialog:false,
      snackbarOK:false,
oktext:'',
      regulators: [],
      nfctag: {
        id: '',
        name: '',
        email: '',
        code: '',
        record: []
      },
      nfctag2: {
        id: '',
        name: '',
        email: '',
        code: '',
        prfolderefix:'',
        record: []
      },
      nfctag22:[],

      show_ov_1: false,
      docs_over: [],
      show_ov_2: false,
      eias_over: [],
      files_over: [],
      reestr_over: [],
      file_links: [],
      index: null,
      drawer: null,
      dis: false,
      show: false,
      navigation: {
        shown: true,
        width: 580,
        borderSize: 3
      },
      deloDoc: {},
    }),
    computed: {
      direction() {
        return this.navigation.shown === false ? "Open" : "Closed";
      }
    },
    methods: {
      NFCCODE() {
        return qs.parse(window.location.search, { ignoreQueryPrefix: true }).NFC
      },
      NFCCODE2() {
        return qs.parse(window.location.search, { ignoreQueryPrefix: true }).NFC2
      },

      sendlink()
      {
        var self = this;

      axios.post(
        'https://zapros.btr-online.ru/sendlinknfc',
        JSON.stringify({
          enter: "123",
          email:self.nfctag.email,
          code: self.nfctag.code
        })
      )
        .then(function (response) {

          self.oktext = response.data;
          self.snackbarOK=true;

        })

      },
      
    },
    mounted() {


      var self = this;

       if (self.NFCCODE())
       {

      axios.post(
        'https://zapros.btr-online.ru/Getregulator',
        JSON.stringify({
          enter: "123",
        })
      )
        .then(function (response) {

          self.regulators = response.data;

        })

      }

      if ((self.NFCCODE()) && (!self.NFCCODE2())) {
        axios.post(
          'https://zapros.btr-online.ru/GetNFC',
          JSON.stringify({
            enter: "123",
            CODE: self.NFCCODE()
          })
        )
          .then(function (response) {

            self.nfctag = (response.data)[0];

          })

      }

        if ((self.NFCCODE2()) && (!self.NFCCODE())) {
        axios.post(
          'https://zapros.btr-online.ru/GetNFC2',
          JSON.stringify({
            enter: "123",
            code2: self.NFCCODE2()
          })
        )
          .then(function (response) {

           
            

            self.nfctag2 = (response.data[0][0]);
            self.nfctag22 =response.data[1];
            self.nfctag2.record=JSON.parse(self.nfctag2.record)

            self.nfctag22.forEach((element,i) => {

              self.nfctag22[i].podachi=JSON.parse(element)
             


              
            });
            
            
          })

      }




    },
  };

</script>
<style>
  
  @keyframes movinglight {
	0% {
		border-radius:300px; width:300px; height:300px;
    opacity:100%;
	}

	25% {
		border-radius:150px; width:150px; height:150px;
    opacity:60%;
	}

	50% {
	border-radius:5px; width:5px; height:5px;
  opacity:30%;
	}

  75% {
		border-radius:150px; width:150px; height:150px;

    opacity:60%;
	}

  100% {
		border-radius:300px; width:300px; height:300px;
    opacity:100%;
	}


}
  .image {
    float: top;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center center;
    border: 10px solid #ebebeb;

    margin: 0 auto;
    margin-top: 25px;
    margin-bottom: 25px;
  }

  .link {
    border-top: 78px solid transparent;
    margin-top: -78px;
    padding: 15px;
    -moz-background-clip: padding;
    -webkit-background-clip: padding-box;
    background-clip: padding-box;
  }


  /* Modern browsers — Chrome 121+, Edge 121+, Firefox, Safari 18.2+ */
* {
  scrollbar-width: 8px;
  scrollbar-color: #6366f1 #1e1b4b;
}

/* Legacy WebKit — older Chrome/Edge/Safari, radius, borders & shadows */
*::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

*::-webkit-scrollbar-track {
  background-color: #1e1b4b;
  border-radius: 4px;
  padding: 1px;
}

*::-webkit-scrollbar-track:hover {
  background-color: #312e81;
}

*::-webkit-scrollbar-track:active {
  background-color: #3730a3;
}

*::-webkit-scrollbar-thumb {
  background-color: #6366f1;
  border-radius: 4px;
  min-height: 30px;
  box-shadow: 0 0 6px rgba(129,140,248, 0.60);
}

*::-webkit-scrollbar-thumb:hover {
  background-color: #818cf8;
}

*::-webkit-scrollbar-thumb:active {
  background-color: #a5b4fc;
}

*::-webkit-scrollbar-button {
  display: none;
  width: 0;
  height: 0;
}
</style>